import React, { BaseSyntheticEvent } from 'react'
import { IonList, IonItem, IonCol, IonRow, IonLabel } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedOption } from '../store/initialAssessment.actions'
import { InitialAssessmentConstants } from '../store/initialAssessment.constants'
import { getInitialAssessmentSelector } from '../selectors'

const InitialAssessmentTablet = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { selectedOption } = useSelector(getInitialAssessmentSelector)
  const { isTablet } = useDeviceMetrics()

  const navigateToNeuro = (e: BaseSyntheticEvent) => {
    dispatch(setSelectedOption(InitialAssessmentConstants.NEURO))
  }

  const navigateToRespiratory = (e: BaseSyntheticEvent) => {
    dispatch(setSelectedOption(InitialAssessmentConstants.RESPIRATORY))
  }
  const navigateToAirway = (e: BaseSyntheticEvent) => {
    dispatch(setSelectedOption(InitialAssessmentConstants.AIRWAY))
  }
  const navigateToCardio = (e: BaseSyntheticEvent) => {
    dispatch(setSelectedOption(InitialAssessmentConstants.CARDIO))
  }

  const isRowSelected = (rowName: string): boolean => {
    return isTablet && selectedOption === rowName
  }

  return (
    <IonList className={'list-sidebar'}>
      <IonItem
        data-testid='Neuro'
        onClick={navigateToNeuro}
        className={isRowSelected(InitialAssessmentConstants.NEURO) ? 'aqua-base' : ''}>
        <IonCol className='ion-padding'>
          <IonRow>
            <IonLabel color='dark'>
              <h2>{t('fullChart.patient.initialAssessment.Neuro')}</h2>
            </IonLabel>
          </IonRow>
          <IonRow>
            <IonLabel color='medium'>
              <h3>{t('fullChart.patient.initialAssessment.NeuroDetails')}</h3>
            </IonLabel>
          </IonRow>
        </IonCol>
      </IonItem>
      <IonItem
        data-testid='Airway'
        onClick={navigateToAirway}
        className={isRowSelected(InitialAssessmentConstants.AIRWAY) ? 'aqua-base' : ''}>
        <IonCol className='ion-padding'>
          <IonRow>
            <IonLabel color='dark'>
              <h2>{t('fullChart.patient.initialAssessment.Airway')}</h2>
            </IonLabel>
          </IonRow>
          <IonRow>
            <IonLabel color='medium'>
              <h3>{t('fullChart.patient.initialAssessment.AirwayDetails')}</h3>
            </IonLabel>
          </IonRow>
        </IonCol>
      </IonItem>
      <IonItem
        data-testid='Respiratory'
        onClick={navigateToRespiratory}
        className={isRowSelected(InitialAssessmentConstants.RESPIRATORY) ? 'aqua-base' : ''}>
        <IonCol className='ion-padding'>
          <IonRow>
            <IonLabel color='dark'>
              <h2>{t('fullChart.patient.initialAssessment.Respiratory')}</h2>
            </IonLabel>
          </IonRow>
          <IonRow>
            <IonLabel color='medium'>
              <h3>{t('fullChart.patient.initialAssessment.RespiratoryDetails')}</h3>
            </IonLabel>
          </IonRow>
        </IonCol>
      </IonItem>
      <IonItem
        data-testid='Cardio'
        onClick={navigateToCardio}
        className={isRowSelected(InitialAssessmentConstants.CARDIO) ? 'aqua-base' : ''}>
        <IonCol className='ion-padding'>
          <IonRow>
            <IonLabel color='dark'>
              <h2>{t('fullChart.patient.initialAssessment.Cardio')}</h2>
            </IonLabel>
          </IonRow>
          <IonRow>
            <IonLabel color='medium'>
              <h3>{t('fullChart.patient.initialAssessment.CardioDetails')}</h3>
            </IonLabel>
          </IonRow>
        </IonCol>
      </IonItem>
    </IonList>
  )
}

export default InitialAssessmentTablet
